import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { config } from '../config';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';

const apiUrl = config.apiUrl;
const imageUrl = config.imageUrl;

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/services`);
        setServices(response.data.services);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [apiUrl]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-pulse flex flex-col items-center">
          <div className="w-16 h-16 bg-indigo-300 rounded-full mb-4"></div>
          <div className="text-xl font-semibold text-indigo-600">Loading Services...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div className="bg-gradient-to-b from-indigo-50 to-white min-h-screen">
        {/* Hero Section */}
        <div className="py-16 px-5 text-center bg-indigo-600 text-white pt-32">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">আমাদের সেবা সমূহ</h1>
          <p className="text-xl max-w-3xl mx-auto">পেশাদার সেবা যা আপনার জীবনকে সহজ করে তোলে</p>
          <div className="mt-8">
            <button 
              onClick={() => navigate('/contact')}
              className="px-8 py-3 bg-white text-indigo-600 font-bold rounded-full hover:bg-indigo-100 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              প্রশ্ন থাকলে জিজ্ঞাসা করুন
            </button>
          </div>
        </div>

        {/* Services Grid */}
        <div className="container mx-auto py-12 px-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div
                key={service.id}
                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col"
              >
                <div className="relative">
                  <img
                    src={`${imageUrl}/${service.image}`}
                    alt={service.service_name}
                    className="w-full h-64 object-cover"
                  />
                  {service.discount_price && (
                    <div className="absolute top-4 right-4 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold">
                      {Math.round(((service.selling_price - service.discount_price) / service.selling_price) * 100)}% OFF
                    </div>
                  )}
                </div>
                
                <div className="p-6 flex-grow">
                  <h2 className="text-2xl font-bold mb-3 text-gray-800">{service.service_name}</h2>
                  <div 
                    className="text-gray-600 mb-4 line-clamp-3" 
                    dangerouslySetInnerHTML={{ __html: service.description }}
                  ></div>
                  
                  {service.duration && (
                    <div className="flex items-center text-gray-500 mb-3">
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span>{service.duration}</span>
                    </div>
                  )}
                </div>
                
                <div className="px-6 pb-6">
                  <div className="flex justify-between items-center mb-4">
                    <div>
                      {service.discount_price ? (
                        <>
                          <span className="text-2xl font-bold text-indigo-600">{service.discount_price} BDT</span>
                          <span className="ml-2 text-sm text-gray-500 line-through">{service.selling_price} BDT</span>
                        </>
                      ) : (
                        <span className="text-2xl font-bold text-indigo-600">{service.selling_price} BDT</span>
                      )}
                    </div>
                    <button 
                      onClick={() => navigate(`/purchase/service/${service.id}`)}
                      className="px-6 py-2 bg-indigo-600 text-white rounded-full hover:bg-indigo-700 transition-all flex items-center"
                    >
                      কিনুন
                      <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="bg-indigo-700 text-white py-12 px-5 text-center">
          <h2 className="text-3xl font-bold mb-4">কোন সেবা সম্পর্কে জানতে চান?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">আমাদের বিশেষজ্ঞরা আপনার সকল প্রশ্নের উত্তর দিতে প্রস্তুত</p>
          <button 
            onClick={() => navigate('/contact')}
            className="px-8 py-3 bg-white text-indigo-600 font-bold rounded-full hover:bg-indigo-100 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            যোগাযোগ করুন
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Services;